import classNames from 'classnames';
import fetch from 'isomorphic-fetch';
import React, { Component } from 'react';

import {
  SHARE_MENU_ACTION_FB_SHARE,
  SHARE_MENU_ACTION_GM_SHARE,
  SHARE_MENU_ACTION_LINK,
  SHARE_MENU_ACTION_TW_SHARE,
} from 'constants/events';
import * as analytics from 'utilities/analytics';
import * as sentry from 'utilities/sentry';
import { getAnimatedPreview } from 'utilities/video';

import CopyLinkDropdownItem from '../copy-link-dropdown-item';
import EmbedCodeDropdownItem from '../embed-code-dropdown-item';
import EmbedThumbnailDropdownItem from '../embed-thumbnail-dropdown-item';
import FacebookDropdownItem from '../facebook-dropdown-item';
import GmailDropdownItem from '../gmail-dropdown-item';
import TwitterDropdownItem from '../twitter-dropdown-item';

import DropdownMenu from 'components/dropdown-menu';

import './styles.less';

class ShareDropdownMenu extends Component {
  static defaultProps = {
    show: false,
    onHide: () => {},
    align: 'left',
    vAlign: 'auto',
  };

  render() {
    const {
      additionalClass,
      currentUserIsOwner,
      hasGmailAccount,
      showFacebook = true,
      video,
      show: dropdownOpen,
      align,
      vAlign,
      handleEmbedCodeClick = null,
      handleEmbedThumbClick = null,
    } = this.props;

    const showLinkedGif = Boolean(getAnimatedPreview(video));

    return (
      <DropdownMenu
        show={dropdownOpen}
        align={align}
        vAlign={vAlign}
        additionalClass={classNames(additionalClass, 'share-dropdown')}
      >
        <CopyLinkDropdownItem
          onClick={this.handleCopyLinkClick}
          video={video}
        />
        {showLinkedGif && handleEmbedThumbClick && (
          <EmbedThumbnailDropdownItem onClick={handleEmbedThumbClick} />
        )}
        {handleEmbedCodeClick && (
          <EmbedCodeDropdownItem onClick={handleEmbedCodeClick} />
        )}
        <div className="embed" />
        <TwitterDropdownItem
          currentUserIsOwner={currentUserIsOwner}
          onClick={this.trackTwitterClick}
          video={video}
        />
        {showFacebook && (
          <FacebookDropdownItem
            currentUserIsOwner={currentUserIsOwner}
            onClick={this.trackFacebookClick}
            video={video}
          />
        )}
        {hasGmailAccount && (
          <GmailDropdownItem onClick={this.trackGmailClick} video={video} />
        )}
      </DropdownMenu>
    );
  }

  handleCopyLinkClick = event => {
    event.stopPropagation();

    analytics.track(SHARE_MENU_ACTION_LINK);

    this.props.onHide();
  };

  trackFacebookClick = () => {
    this.postIfLogged('/api/users/shared-video-on-fb');
    analytics.track(SHARE_MENU_ACTION_FB_SHARE);
  };

  trackTwitterClick = () => {
    this.postIfLogged('/api/users/tweeted-video');
    analytics.track(SHARE_MENU_ACTION_TW_SHARE);
  };

  trackGmailClick = () => {
    analytics.track(SHARE_MENU_ACTION_GM_SHARE);
  };

  postIfLogged = url => {
    const { isLoggedIn } = this.props;

    if (!isLoggedIn) {
      return;
    }

    fetch(url, {
      method: 'POST',
      credentials: 'include',
    }).catch(err => {
      sentry.logException(err, `error POST ${url}`);
    });
  };
}

export default ShareDropdownMenu;
